/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   11/11/21
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {persistState} from "../helpers";

const STORAGE_KEY = 'vega.state.default-calendar-id';
let storedState = localStorage.getItem(STORAGE_KEY);
if (!storedState) {
	const lastState = localStorage.getItem("vega.state.calendar");
	storedState = lastState ? JSON.parse(lastState)?.id ?? 0 : 0;
	localStorage.setItem(STORAGE_KEY, String(storedState));
}
const initialState: number = Number(storedState);

export const slice = createSlice({
	name: 'default-calendar-id',
	initialState,
	reducers: {
		set: (state, action: PayloadAction<number>) => {
			const newState = action.payload;
			persistState(STORAGE_KEY, newState);
			return newState;
		},
	},
});

export const { set } = slice.actions;
export default slice.reducer;